module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_03f.05a8f4d4.jpg";